import { render, staticRenderFns } from "./Ajuda.vue?vue&type=template&id=9fa5a3e8&scoped=true"
import script from "./Ajuda.vue?vue&type=script&lang=js"
export * from "./Ajuda.vue?vue&type=script&lang=js"
import style0 from "./Ajuda.vue?vue&type=style&index=0&id=9fa5a3e8&prod&scoped=true&lang=css"
import style1 from "./Ajuda.vue?vue&type=style&index=1&id=9fa5a3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa5a3e8",
  null
  
)

export default component.exports